import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import theme from './Heading.theme';

export const Heading = styled('h1')`
  font-family: ${props=>theme(props).fontFamily};
  font-weight: 700;
  text-align: ${ifProp('isCenter', 'center', 'left')};
  text-decoration: ${ifProp('hasUnderline', 'underline', 'none')};
`;
